var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCuadrado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "64px",
    viewBox: "0 0 63 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vista01c") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 63,
    height: 63
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "12.121138%",
    x2: "50%",
    y2: "76.060754%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BEFA9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B194",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-4",
    x: 0,
    y: 0,
    width: 63,
    height: 62.999992
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.4%",
    y: "-2.4%",
    width: "104.8%",
    height: "104.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.39215687   0 0 0 0 0.39215687   0 0 0 0 0.39215687  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "-1.6380615 48.8879628 31.4054229 42.587963 64.7009385 48.8879628 64.7009385 64.1024617 -1.6380615 64.102463"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.5%",
    y: "-13.9%",
    width: "109.0%",
    height: "127.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.03137255   0 0 0 0 0.6117647   0 0 0 0 0.5019608  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.6779564,59.7113625 L53.6779521,53.2979595 L55.3058777,53.4239595 L55.3058777,51.7229595 L50.434082,51.2819595 L50.434082,52.9829596 L52.0620079,53.1719594 L52.0620036,59.7113625 L53.6779564,59.7113625 Z M47.8900961,56.2979905 C48.379603,56.655201 48.5912859,56.9065694 48.5912859,57.3431604 C48.5912859,57.8458991 48.2340732,58.2163406 47.8239467,58.2163406 C47.2815141,58.2163406 46.9375369,57.7929812 46.9375369,57.2637793 L46.9375369,56.9065694 L45.257325,56.9065694 L45.257325,57.3828487 C45.257325,58.8249185 46.3686453,59.8171694 47.7974839,59.8171694 C49.2130953,59.8171694 50.4170235,58.8646087 50.4170235,57.2505501 C50.4170235,56.3112208 49.9142852,55.6894096 49.1204833,55.0808295 L47.9033275,54.1547302 C47.3212044,53.7049102 47.0698351,53.5196898 47.0698351,52.9243402 C47.0698351,52.5009802 47.3608947,52.1966898 47.8107153,52.1966898 C48.3266852,52.1966898 48.6309761,52.6332799 48.6309761,53.1360201 L48.6309761,53.5064597 L50.3111842,53.5064597 C50.3111842,53.2947799 50.3111842,53.1889401 50.3111842,53.1889401 C50.31118,51.9535101 49.3460318,50.8610896 47.8504058,50.6090896 C46.5431487,50.404337 45.2837878,51.4558098 45.2837878,53.10956 C45.2837878,54.0753501 45.7336046,54.7633103 46.5803242,55.3586599 L47.8900961,56.2979905 Z M45.0620223,59.711341 L45.0765149,50.1164375 L43.120361,49.858139 L43.120361,59.711341 L45.0620223,59.711341 Z M42.966593,59.711363 L42.966593,57.805613 L39.627593,57.805613 L39.6269624,49.0769571 L37.501343,48.793457 L37.501343,59.711363 L42.966593,59.711363 Z M37.3067756,59.7113446 L34.0408587,53.9573129 L36.9835872,48.8123436 L34.6191979,48.8123436 L32.271818,53.2040001 L32.203777,53.2040001 L32.203777,48.8123436 L29.924438,48.8123436 L29.924438,59.7113446 L32.203777,59.7113446 L32.203777,55.1113257 L32.271818,55.1113257 L34.7042467,59.7113446 L37.3067756,59.7113446 Z M29.6799805,56.3723559 L27.6009803,56.3723559 L27.6009803,56.8448552 C27.6009803,57.4748578 27.1914803,57.9316075 26.6244807,57.9316075 C26.0732305,57.9316075 25.6322305,57.4748578 25.6322305,56.907857 L25.6322305,51.8206026 C25.6322305,51.237852 26.0574807,50.854602 26.6244807,50.7811018 C27.1547357,50.7075995 27.6009803,51.1748522 27.6009803,51.8206026 L27.6009803,52.3246033 L29.6799805,52.3246033 C29.6799805,52.0096039 29.6799805,51.8521043 29.6799805,51.8521043 C29.7009909,50.0461066 28.5459802,48.6443509 26.6717306,48.8753517 C24.8814911,49.2113512 23.505981,50.1353516 23.505981,51.8521043 L23.505981,56.860605 C23.505981,58.5616073 24.8132308,59.8373545 26.5929807,59.8373545 C28.3727305,59.8373545 29.6799805,58.6403585 29.6799805,56.7346062 L29.6799805,56.3723559 Z M23.3403332,59.7113666 L23.3403332,58.0074017 L20.2394744,58.0074017 L20.2394744,55.7260614 L21.8188831,55.7260614 L21.8188831,54.0220945 L20.2394744,54.0220945 L20.2394773,51.8393278 L23.3403345,51.4394599 L23.3415955,49.5179596 L18.283325,50.135363 L18.283325,59.7113666 L23.3403332,59.7113666 Z M17.9582435,59.7113616 L17.9550966,50.1479606 L16.1589661,50.4314606 L16.1589627,54.3664412 L14.4919823,54.3664412 L14.4919886,50.4314606 L12.7059325,50.7149607 L12.7059325,59.7113616 L14.4919823,59.7113616 L14.4919823,55.9672714 L16.1589627,55.9672714 L16.1589627,59.7113616 L17.9582435,59.7113616 Z M12.378274,57.1737144 L10.7982348,57.1737144 L10.7982348,57.5328156 C10.7982348,58.0116134 10.4870145,58.3587394 10.0560948,58.3587394 C9.63714549,58.3587394 9.30198416,58.0116134 9.30198416,57.5806965 L9.30198416,53.7143811 C9.30198416,53.2714901 9.56532998,52.8878369 9.99624386,52.8248362 C10.3941892,52.7618367 10.7383846,53.1240835 10.7383846,53.6148551 L10.7383846,53.9978963 L12.3184243,53.9978963 C12.3184243,53.758495 12.3184243,53.6387944 12.3184243,53.6387944 C12.3184118,52.4760317 11.4658353,51.1244558 10.0321545,51.376464 C8.69758802,51.6704613 7.686035,52.4335898 7.686035,53.7383206 L7.686035,57.5447873 C7.686035,58.8375505 8.67954515,59.807102 10.0321545,59.807102 C11.3847658,59.807102 12.378274,58.8973975 12.378274,57.4490259 L12.378274,57.1737144 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-4.5%",
    width: "102.1%",
    height: "109.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.1764706   0 0 0 0 0.32156864   0 0 0 0 0.39607844  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "43.3011918%",
    x2: "42.36062%",
    y2: "83.7087877%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACF8CB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7F8EB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "43.3011918%",
    x2: "42.36062%",
    y2: "83.7087877%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7F8EB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.2549332,1.124345 C36.7528687,-0.374781355 39.320749,-0.374781355 40.8186889,1.124345 L43.9215507,4.22967926 C45.4194816,5.72880565 45.4194816,8.29873651 43.9215507,9.7978629 L23.8205726,29.8234152 C23.6915304,30.0125528 23.5441611,30.1914851 23.3784586,30.3573194 L20.2756004,33.4626508 C18.7776646,34.9617793 16.2097824,34.9617793 14.7118493,33.4626508 L1.12345005,19.7563457 C-0.374483004,18.2572173 -0.374483004,15.6872878 1.12345005,14.1881586 L4.22631312,11.0828245 C5.72424653,9.58369848 8.29213225,9.58369848 9.79006589,11.0828245 L17.4765532,18.8360099 L35.2549332,1.124345 L35.2549332,1.124345 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.3%",
    y: "-17.3%",
    width: "126.6%",
    height: "134.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.15294118   0 0 0 0 0.7490196   0 0 0 0 0.6039216  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BarMenu",
    transform: "translate(-16.999900, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vista01c",
    transform: "translate(17.000000, 15.600000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#D3D3D3",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-shape-Mask"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "New-shape",
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D6FBF0",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CHECKLIST"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#34586B",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.577759, 8.000973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2549332,1.124345 C36.7528687,-0.374781355 39.320749,-0.374781355 40.8186889,1.124345 L43.9215507,4.22967926 C45.4194816,5.72880565 45.4194816,8.29873651 43.9215507,9.7978629 L23.8205726,29.8234152 C23.6915304,30.0125528 23.5441611,30.1914851 23.3784586,30.3573194 L20.2756004,33.4626508 C18.7776646,34.9617793 16.2097824,34.9617793 14.7118493,33.4626508 L1.12345005,19.7563457 C-0.374483004,18.2572173 -0.374483004,15.6872878 1.12345005,14.1881586 L4.22631312,11.0828245 C5.72424653,9.58369848 8.29213225,9.58369848 9.79006589,11.0828245 L17.4765532,18.8360099 L35.2549332,1.124345 L35.2549332,1.124345 Z",
    id: "Vector-shape",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector-shape-3-Mask",
    transform: "translate(0.251953, 1.952995)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-12)",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.2549619,13.0943194 C36.2535765,12.0948999 39.7059072,8.70661838 45.6119543,2.9294748 C47.1098414,4.42860198 45.4194831,20.2687149 43.9215754,21.7678415 L23.8205795,41.7934025 C23.691535,41.9825434 23.5441778,42.1614747 23.3784665,42.3273072 L20.2755927,45.4326319 C18.7776607,46.9317629 16.2097816,46.9317629 14.7118349,45.4326319 L1.12343853,31.7263249 C-0.374496486,30.2272009 -3.76597606,21.3441098 -2.26804205,19.8449766 L-0.472546082,13.0943194 C5.37056658,18.7338924 8.79143425,22.0533869 9.79005694,23.0528029 L17.4765545,30.8059922 L35.2549619,13.0943194 L35.2549619,13.0943194 Z",
    id: "Vector-shape-3",
    fill: "#BBF6E5",
    mask: "url(#mask-14)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCuadrado);
export default __webpack_public_path__ + "static/media/logo_cuadrado.74a132f815aeba578af0dc92cd52eeb2.svg";
export { ForwardRef as ReactComponent };